import { createVideoPlugin } from './createVideoPlugin.js';
import { VIDEO_TYPE } from './types.js';
import { DEFAULTS } from './defaults.js';
import { ModalsMap } from './modals.js';
import { createVideoData } from './createVideoData.js';
import { tiptapExtensions } from './tiptap/tiptap.js';
import { getAddButtons } from './getAddButtons.js';
import { getToolbarButtons } from './getToolbarButtons.js';
import './toolbar/createToolbar.js';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import './toolbar/videoModal.js';
import 'react';
import 'prop-types';
import './toolbar/videoSelectionInputModal.js';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import './style-inject.es-746bb8ed.js';
import 'react-player';
import './toolbar/videoPluginService.js';
import 'lodash';
import './toolbar/mediaURLInputModal.js';
import './toolbar/NewVideoModal.js';
import './toolbar/NewVideoInsertModal.js';
import 'classnames';
import './toolbar/videoUploadModal.js';
import './toolbar/NewMediaUrlInputModal.js';
import 'ricos-context';
import './toolbar/selectionModalCustomStyles.js';
import './constants.js';
import 'ricos-schema';
import './icons/MediaReplaceIcon.js';
import './toolbar/insert-buttons.js';
import './video-component.js';
import 'react-dom';
import './video-viewer.js';
import './reactPlayerWrapper.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import './get-video-source.js';
import './IframePlayer.js';
import './video-viewer-200c0e68.js';
import './default-video-styles-ee165d52.js';
import './icons/VideoInsertPluginIcon.js';
import './icons/SoundCloudInsertPluginIcon.js';
import './icons/YoutubeIcon.js';
import './toolbar/VideoSettings.js';
import './toolbar/ControlsSection.js';
import 'ricos-content/libs/toDraftData';
import 'ricos-content';
import 'ricos-schema/dist/statics/video.defaults.json';
import './tiptap/component.js';
import './tiptap/video-component.js';
import './viewer/video-viewer.js';
import './modals/InsertModal.js';
import 'ricos-content/libs/convertBlockDataToRicos';
import 'ricos-types';
import './modals/SettingsModal.js';
import 'wix-rich-content-toolbars-ui';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginVideo = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: VIDEO_TYPE,
    createPlugin: createVideoPlugin,
    ModalsMap,
    createPluginData: createVideoData,
    tiptapExtensions,
    getAddButtons: (config2, services) => getAddButtons(config2),
    toolbar: { getButtons: (config2, services) => getToolbarButtons(config2, services) }
  };
};

export { pluginVideo };
//# sourceMappingURL=editor.js.map
